import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
import { fontSize } from './fontSize';
import { fontWeight } from './fontWeight';
const baseStyles = css `
  color: ${themeGet('colors.gray.800')};
  font-style: normal;
`;
export const formLabel = css `
  ${baseStyles};
  font-size: ${themeGet('fontSize.small')};
  font-weight: ${themeGet('fontWeight.semibold')};
  line-height: ${themeGet('lineHeight.neutralized')};
  color: ${themeGet('colors.gray.600')};
  display: inline-block;
`;
export const bodyContent = css `
  ${baseStyles};
  ${fontSize('base')};
  ${fontWeight('normal')};
`;
export const meta = css `
  ${baseStyles}
  ${fontWeight('normal')};
  ${fontSize('tiny')};
  font-style: normal;
  color: ${themeGet('colors.gray.400')};
`;
export const link = css `
  ${baseStyles}
  ${fontWeight('normal')};
  ${fontSize('small', pxToRem(24))};
  font-style: normal;
  color: ${themeGet('colors.secondary.500')};
  text-decoration: none;
`;
export const linkHover = css `
  ${link}
  text-decoration-line: underline;
`;
export const code = css `
  ${baseStyles}
  ${fontWeight('normal')};
  ${fontSize('small', pxToRem(24))};
`;
